import { render, staticRenderFns } from "./points_exchange.vue?vue&type=template&id=1fa3238c&scoped=true&"
import script from "./points_exchange.vue?vue&type=script&lang=js&"
export * from "./points_exchange.vue?vue&type=script&lang=js&"
import style0 from "./points_exchange.vue?vue&type=style&index=0&id=1fa3238c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3238c",
  null
  
)

export default component.exports